import { Capacitor } from "@capacitor/core";

export const ANDROID_RELEASE_APP_VERSION = "1.0.4 (150)";
export const IOS_RELEASE_APP_VERSION = "1.0.4 (142)";
export const WEB_RELEASE_APP_VERSION = "1.0.4 (web-142)";

// Kept as a compatibility export for non-runtime tests and older integrations.
export const RELEASE_APP_VERSION = WEB_RELEASE_APP_VERSION;

export function getPlatformReleaseAppVersion() {
  const platform = Capacitor.getPlatform();
  if (platform === "android") return ANDROID_RELEASE_APP_VERSION;
  if (platform === "ios") return IOS_RELEASE_APP_VERSION;
  return WEB_RELEASE_APP_VERSION;
}

export function getRuntimeAppVersion() {
  return import.meta.env.VITE_APP_VERSION || import.meta.env.VITE_RELEASE_VERSION || getPlatformReleaseAppVersion();
}
